var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialsGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98.92 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.46,100l49.46-18.84-27.26-10.39,27.26-10.39-27.26-10.39,27.26-10.39-27.26-10.39,27.26-10.39L49.46,0,0,18.84l27.26,10.39L0,39.61l27.26,10.39L0,60.39l27.26,10.39L0,81.16l49.46,18.84ZM11.67,18.84L49.46,4.45l37.79,14.4-21.43,8.16h0l-16.36,6.23-16.36-6.23h0l-21.43-8.16ZM11.67,39.61l21.43-8.16,16.36,6.23,16.36-6.23,21.43,8.16-21.43,8.16h0l-16.36,6.23-16.36-6.23h0l-21.43-8.16ZM11.67,60.39l21.43-8.16,16.36,6.23,16.36-6.23,21.43,8.16-21.43,8.16h0l-16.36,6.23-16.36-6.23h0l-21.43-8.16ZM65.82,73l21.43,8.16-37.79,14.4-37.79-14.4,21.43-8.16,16.36,6.23,16.36-6.23Z",
    fill: "#2cc749"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialsGreen);
export default __webpack_public_path__ + "static/media/materials-green.e921f2575828d2e35512dbb0e4c07618.svg";
export { ForwardRef as ReactComponent };